/* eslint-disable camelcase */
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  EarlyExerciseConfigurationService,
  type Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto,
} from '@wealthlane/api-services/wealthlane-award-settlement-service';

const usePostEarlyExerciseConfig = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseMutationResult<
  Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      return await handleRequest(
        EarlyExerciseConfigurationService.postApiAwardSettlementApiAppEarlyExerciseConfigurationConfigureEarlyExerciseConfiguration(
          payload
        )
      );
    },
    {
      onSuccess: async (response) => {
        if (response != null) {
          toast.success(<ToastComponent label='Success' message={'Configuration saved'} />);
          await queryClient.invalidateQueries('getEarlyExerciseConfig');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostEarlyExerciseConfig;
